import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=c804c33e&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=c804c33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c804c33e",
  null
  
)

export default component.exports